import { FloatingLabel, FormControl, FormLabel } from "react-bootstrap";
import styled from "styled-components";

const StyledFormControl = styled(FormControl)`
    border: 1px solid #787878 !important;
    width: 100%;
    border-radius: 4px;
    height: 48px;
    &:hover {
        border: 1px solid #9654ff !important;
        box-shadow: none;
    }
    &:active {
        border: 1px solid #9654ff !important;
        box-shadow: none;
    }
    &:focus {
        border: 1px solid #9654ff !important;
        box-shadow: none;
    }
    &:focus-visible {
        border: 1px solid #9654ff !important;
        box-shadow: none;
    }
`;

const StyledFloatingLabel = styled(FloatingLabel)`
    label {
        top: -5px;
        font-size: 14px;
    }
    .form-control {
        height: 48px;
        line-height: 1.25;
    }
    .form-control-plaintext {
        height: 48px;
        line-height: 1.25;
    }
    .form-select {
        height: 48px;
        line-height: 1.25;
    }
`;

const StyledLabel = styled(FormLabel)`
    font-size: 15px;
    line-height: 25px;
    margin: 0;
    margin-bottom: 0;
`;

export default {
    StyledFormControl,
    StyledFloatingLabel,
    StyledLabel,
};
